import { FC, Dispatch, SetStateAction, MutableRefObject } from 'react';
import cx from 'classnames/bind';

import { Hint } from '@/components/Hint';
import Completion from '../Completion';
import UnSuccessfulCompletion from '@/assets/unsuccessfulCompletion.png';
import { SuccessfulCompletion } from '../contants';
import type { IGame } from '@/types/game';

import styles from './CompletionScript.module.scss';

interface CompletionScriptProps {
  isSuccess: boolean;
  numberQuestions: number;
  receivedPoints: number;
  setStep: (value: number) => void;
  scenarios: IGame[];
  idGame: number;
  setPoints: Dispatch<SetStateAction<number>>;
  setIdGame: Dispatch<SetStateAction<number>>;
  isCompletedGameRef: MutableRefObject<boolean | undefined>;
  setCurrentScenarioIndex: Dispatch<SetStateAction<number>>;
  costPerQuestion: number;
}

const cn = cx.bind(styles);

const CompletionScript: FC<CompletionScriptProps> = ({
  isSuccess,
  numberQuestions,
  receivedPoints,
  setStep,
  scenarios,
  idGame,
  setPoints,
  setIdGame,
  isCompletedGameRef,
  setCurrentScenarioIndex,
  costPerQuestion,
}) => {
  const handleClick = () => {
    const lastScenario = scenarios[scenarios.length - 1];
    const lastScenarioId = scenarios[scenarios.length - 1].id;
    const isCompletedGames = lastScenario.status;

    if (isCompletedGames && idGame === lastScenarioId) {
      setStep(14);
    } else {
      if (isSuccess) {
        const nextIndex = scenarios.findIndex(({ id }) => id === idGame) + 1;
        const nextId = scenarios.find((_item, index) => index === nextIndex)
          ?.id!;

        setCurrentScenarioIndex(nextIndex);
        setIdGame(nextId);
      } else {
        const currentIndex = scenarios.findIndex(({ id }) => id === idGame);
        const currentId = scenarios.find(
          (_item, index) => index === currentIndex,
        )?.id!;

        setCurrentScenarioIndex(currentIndex);
        setIdGame(currentId);
      }
      setStep(9);
    }
    setPoints(0);
  };

  const description = isSuccess
    ? 'Вы успешно прошли сценарий. Баллы будут начислены только после полного прохождения всех сценариев.'
    : 'Чтобы перейти к следующему сценарию и продолжить активность, вам нужно правильно выполнить текущий сценарий.';

  const src = isSuccess ? SuccessfulCompletion : UnSuccessfulCompletion;

  const isScenarioWithPoints = scenarios.find(({ id }) => id === idGame)
    ?.isScore;

  return (
    <div className={cn('container')}>
      {numberQuestions &&
        !isCompletedGameRef.current &&
        isScenarioWithPoints && (
          <Hint
            className={cn('hint')}
            points={numberQuestions * costPerQuestion}
            receivedPoints={receivedPoints}
          >
            За прохождение
            <br />
            вы получили
          </Hint>
        )}
      <Completion
        handleClick={handleClick}
        src={src}
        title={isSuccess ? 'Сценарий завершен' : 'Сценарий пройден неправильно'}
        description={description}
        buttonText="Продолжить"
      />
    </div>
  );
};

export default CompletionScript;
